export default __webpack_public_path__ + "OpenSans-SemiBoldItalic-63afadbae2f41f427a56754abd54f461.ttf";